import { registerUser } from '@/services/api/auth';
import { RegisterPayload, RegisterResponse } from '@/types/api/auth';
import { ApiErrorResponse } from '@/types/api/common';
import { useMutation } from '@tanstack/react-query';

export const useRegister = () => {
  return useMutation<RegisterResponse, ApiErrorResponse, RegisterPayload>({
    mutationFn: (payload) => registerUser(payload),
  });
};
